import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

export default {
  strict: true,
  actions,
  getters,
  state: {
    isFetchingAdmin: false,
    netToken: null,
    netInvoices: [],
  },
  mutations,
};
